import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

class Logout extends React.Component {
    constructor(props){
        super(props);
        
    }
    componentDidMount(){
        localStorage.clear();
        this.props.client.resetStore();
        this.props.history.push("/");
        window.location.reload();
    }
    render(){
        return( <div></div> )
    }
}
export default withApollo(withRouter(Logout));


// WEBPACK FOOTER //
// ./src/views/auth/components/Logout.js